import type { ObjecttypeDto, ObjecttypeListingDto } from 'cadenza/api-client/dto/objecttype-dto';

// This file is meant for generic acquisition layer utilities, which are independent of a workbook redux store
// and thus can be used not only in a workbook, but for example also in the management center.
// To have access to the workbook redux store, please use workbook-attribute-util.

export const OL_DEFAULT_MAP_SRS = 'EPSG:3857';

export function isTemplateObjecttype(objecttype: ObjecttypeDto | ObjecttypeListingDto) {
  return objecttype.properties?.['is-acquisition-template'] === 'true';
}

export function isAcquisitionObjecttype(objecttype: ObjecttypeDto) {
  // Acquisition OTs have a source OT defined
  return !!objecttype.properties?.['source-acquisition-template'];
}
